<template id="chart">
  <div class="vx-row">
    <div class="vx-col mb-base w-full">
      <vx-card :title="title">
        <h3 class="text-warning mb-4" v-if="series.length == 0">
          Ni podatkov za prikaz
        </h3>
        <div v-if="series && series.length != 0" class="flex justify-center">
          <VueApexCharts
            :type="type"
            class="m-2"
            :options="options"
            :series="series"
          ></VueApexCharts>
        </div>
        <h4 v-if="topLabel.length !== 0">{{ topLabel }}</h4>
        <h4 v-if="bottomLabel.length !== 0">{{ bottomLabel }}</h4>
        <div class="mt-2" v-if="displayNumberPicker">
          <p>V grafu prikaži vse, ki imajo število parkirnih mest več kot:</p>
          <vs-input-number v-model="number" />
        </div>
      </vx-card>
    </div>
  </div>
</template>
<script>
import VueApexCharts from "vue-apexcharts";
export default {
  template: "#chart",
  name: "chart",
  components: { VueApexCharts },
  props: {
    options: {
      type: Object,
    },
    series: {
      type: Array,
    },
    type: {
      type: String,
    },
    title: {
      type: String,
    },
    topLabel: {
      type: String,
      default: "",
    },
    bottomLabel: {
      type: String,
      default: "",
    },
    minimumDataShownNumber: {
      type: Number,
      default: 0,
    },
    displayNumberPicker: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      number: 1,
    };
  },
  watch: {
    number: function (newValue, old) {
      this.$emit("minimum-number-changed", newValue);
    },
  },
  created() {
    this.number = parseInt(this.minimumDataShownNumber);
  },
};
</script>
